import React from 'react';
import { Form } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  CustomInputNumber,
  ResponsiveRadioGroup,
  StyledRadioButton,
} from './styles';

export function AlarmThresholdFields() {
  const { t } = useTranslation('create-alarm-step');

  return (
    <>
      <Form.Item
        name="thresholdMeasure"
        label={t('create-alarm-step:stepTwo.createAlarmThresholdMeasureField')}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmThresholdMeasureFieldRequired',
            ),
          },
        ]}
      >
        <ResponsiveRadioGroup optionType="button">
          <StyledRadioButton value="qtd_min" position="left">
            {t(
              'create-alarm-step:stepTwo.createAlarmThresholdMeasureBelowField',
            )}
          </StyledRadioButton>
          <StyledRadioButton value="qtd_max" position="right">
            {t(
              'create-alarm-step:stepTwo.createAlarmThresholdMeasureAboveField',
            )}
          </StyledRadioButton>
        </ResponsiveRadioGroup>
      </Form.Item>

      <Form.Item
        name="thresholdValue"
        label={t('alerts:modal-create-fields.value-to-trigger-field')}
        rules={[
          {
            required: true,
            message: t('alerts:msgs.threshold-required'),
          },
        ]}
      >
        <CustomInputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
    </>
  );
}
